angular
  .module("convenzionamento.components", [])
  .component("convenzionamento", {
    templateUrl: "ng/components/convenzionamento/convenzionamento.html",
    bindings: {
      configSearch: "<",
      vendorManag: "<",
      gestioneFornitori: "<",
    },
    controller: ConvenzionamentoController,
    controllerAs: "convenzionamentoCtrl",
  });

function ConvenzionamentoController(
  $configService,
  $rootScope,
  $financialService
) {
  var self = this;

  self.$onInit = function () {
    self.convenzionamento = {
      listProfiloFornitore: null,
      listTipoConvenzionamento: [],
      listManutenzione: [],
      serviziManutenzione: false,
      listProdottiFinanziari: [],
      listServiziAssicurativi: [],
      listini: [],
      listListiniFinanziari: []
    };
    self.ndgListinoFin = null;
    getConvenzionamento();
    self.gestioneFornitorePlus = $configService.getAppConfig().allFunctionalities.includes("GESTIONE_FORNITORE_PLUS") ? true : false
    self.isAgente = $configService.getAppConfig().user.type == 'VENDOR_AGENT' ? true : false;
  };

  var getConvenzionamento = function () {
    self.convenzione = self.gestioneFornitori.convenzionamento;
    self.convenzionamento.serviziManutenzione =
      self.gestioneFornitori.convenzionamento.serviziManutenzione == true
        ? "true"
        : "false";
    Object.keys(self.convenzione).forEach(function (list) {
      if (
        list == "listManutenzione" ||
        list == "listProdottiFinanziari" ||
        list == "listServiziAssicurativi" ||
        list == "listTipoConvenzionamento" ||
        list == "listini" ||
        list == "listListiniFinanziari"
      ) {
        if (
          self.convenzione &&
          self.convenzione[list] &&
          typeof self.convenzione[list] == "object"
        ) {
          if (list == "listListiniFinanziari") {
            self.convenzionamento[list] = self.convenzione[list];
          } else {
            self.convenzione[list].forEach(function (listObj) {
              if (listObj.selected) {
                self.convenzionamento[list].push(listObj);
              }
            });
          }
        }
      }
    });
  };

  self.handleChange = function (value, property) {
    switch (property) {
      case "showMaintenanceServices":
        self.gestioneFornitori.convenzionamento.serviziManutenzione = value;
        self.showMaintenanceServicesMultiselect = value;
        if (value && self.convenzionamento.listManutenzione.length) {
          self.convenzionamento.listManutenzione.forEach(function (el) {
            self.convenzione.listManutenzione.forEach(function (listElement) {
              if (el.value == listElement.value) {
                listElement.selected = true;
              }
            });
          });
        }
        break;
      case "ndgListinoFin":
        self.ndgListinoFin = value;
    }
    self.gestioneFornitori.convenzionamento = self.convenzione;
  };

  self.handleChangeMultiSelect = function (value, prop) {
    self.convenzione[prop].forEach(type => {
      type.selected = false;
    })
    switch (prop) {
      case "listProdottiFinanziari":
      case "listManutenzione":
      case "listServiziAssicurativi":
        self.convenzione[prop].forEach(type => {
          value.forEach(x => {
            if (x.name == type.name) {
              type.selected = true;
            }
          })
        })

        break;

      case 'listini':
        self.convenzione[prop].forEach(type => {
          value.forEach(x => {
            if (x.id == type.id) {
              type.selected = true;
            }
          })
        })
        break;

      default:
        break;
    }


    self.gestioneFornitori.convenzionamento = self.convenzione;
  };

  self.confirmConvenzione = function () {
    if (!self.showMaintenanceServicesMultiselect) {
      self.convenzione.listManutenzione.forEach(function (listObj) {
        listObj.selected = false;
      });
    }
    self.convenzione.listListiniFinanziari = self.convenzionamento.listListiniFinanziari
    self.isConfirm = true;
    $financialService
      .saveConvenzionamento(
        self.convenzione,
        self.gestioneFornitori.idOperation
      )
      .then(function (response) {
        if (response.success) {
          self.convenzione.dataConferma = response.convenzione.dataConferma;
          self.convenzione.utente = response.convenzione.utente;
          self.convenzione.verificato = response.convenzione.verificato;
          $rootScope.$broadcast("addAlert", {
            text: "CONVENTION_OK",
          });
          self.vendorManag.mandatorySteps.conventionRequestSent = true;
          self.gestioneFornitori.conventionRequestSent = true;
        }
        self.isConfirm = false;
      })
      .catch(function (err) {
        console.log(err);
        self.isConfirm = false;
      });
  };

  self.addNdgListinoFin = function () {
    self.isAddingNdgListinoFin = true;
    $financialService
      .checkNdgListino(self.ndgListinoFin)
      .then(function (response) {
        if (response.success) {
          self.convenzionamento.listListiniFinanziari.push(self.ndgListinoFin);
          self.ndgListinoFin = null;
        } else {
          $rootScope.$broadcast("addAlert", {
            text: "LISTINO_NOT_FOUND",
          });
        }
        self.isAddingNdgListinoFin = false;
      })
      .catch(function (err) {
        console.log(err);
        self.isAddingNdgListinoFin = false;
      });
  };

  self.removeNdgListinoFin = function (ndg) {
    self.convenzionamento.listListiniFinanziari = self.convenzionamento.listListiniFinanziari.filter(function (x) {
      return ndg != x
    })
  }
}